import React from "react";
import BlogPostLayout, { Section, Split, Cta } from "./Blogpostlayout.tsx";

const Blogpage2: React.FC = () => {
  return (
    <BlogPostLayout
      title="Managing IT Services: A Practical Guide (with Leadership Essentials)"
      date="August 29, 2025"
      readTime="5 min read"
      heroImg="https://placehold.co/1200x600/1f2937/d1d5db?text=IT+Service+Management"
      heroAlt="IT Service Management"
      tags={["ITSM", "SRE", "Leadership"]}
      intro="Building a resilient IT services function requires more than just technical expertise. It's about defining clear processes, setting measurable goals, and fostering a culture of continuous improvement. This guide outlines the key pillars of modern IT service management and the leadership qualities needed to truly drive outcomes."
    >
      <Section title="The Pillars of Modern IT Service Management">
        <Split
          src="https://placehold.co/600x400/1f2937/d1d5db?text=IT+Processes"
          alt="IT Processes"
          caption="Well-defined processes are the backbone of efficient IT services."
        >
          <h3 style={{ marginTop: 0 }}>Service Catalog &amp; SLAs/OLAs</h3>
          <ul>
            <li>
              Define services (e.g., “Managed Cloud,” “Helpdesk L1/L2”) with scope, hours, SLAs, and
              escalation paths.
            </li>
          </ul>

          <h3>Core ITSM Processes</h3>
          <ul>
            <li><strong>Incident:</strong> Restore service fast (major vs. minor, on-call schedules).</li>
            <li><strong>Problem:</strong> Root cause, permanent fix tracking.</li>
            <li><strong>Change:</strong> CAB/lightweight approvals, change windows, rollback plans.</li>
            <li><strong>Request:</strong> Standardize via catalog items + automation.</li>
          </ul>

          <h3>SRE Practices</h3>
          <ul>
            <li>SLOs, error budgets, blameless postmortems, reliability roadmaps.</li>
          </ul>

          <h3>Measurement &amp; Reporting</h3>
          <ul>
            <li>
              DORA (lead time, deploy frequency, MTTR, change failure rate), CSAT, SLA attainment, cost per
              ticket, backlog age.
            </li>
          </ul>
        </Split>
      </Section>

      <Section title="Leadership Qualities That Actually Move the Needle">
        <Split
          flip
          src="https://placehold.co/600x400/1f2937/d1d5db?text=Leadership+in+IT"
          alt="Leadership in IT"
          caption="Effective leadership is a crucial component of a successful IT organization."
        >
          <ul>
            <li><strong>Clarity &amp; Prioritization:</strong> Communicate trade-offs; protect focus.</li>
            <li><strong>Servant Leadership:</strong> Remove blockers, empower ICs.</li>
            <li><strong>Data-Driven Decisions:</strong> Use metrics to guide—not punish.</li>
            <li><strong>Calm Under Fire:</strong> Clear comms during incidents, crisp after-action notes.</li>
            <li><strong>Change Management:</strong> Set context → co-create → train → reinforce.</li>
          </ul>
        </Split>
      </Section>

      <Cta
        title="Need our SLA templates and dashboards?"
        text="Request the free toolkit."
        label="Get the Toolkit"
      />
    </BlogPostLayout>
  );
};

export default Blogpage2;